import React from 'react';
import './Speakers from.css';
import Microsoft from "../../img/SF/Microsoft.png";
import Bangla from "../../img/SF/Bangla.png";
import Doist from "../../img/SF/Doist.png";
import FreeNow from "../../img/SF/Free Now.png";
import HokenTech from "../../img/SF/Hoken Tech.png";
import PicsartArmenia from "../../img/SF/PicsartArmenia.png";
import SensibleMobile from "../../img/SF/SensibleMobile.png";
import StandardBroadcast from "../../img/SF/StandardBroadcast.png";
import TBC from "../../img/SF/TBC Bank.png";
import Xamarin from "../../img/SF/Xamarin.png";
import Konfio from "../../img/SF/Konfio.png";
import Manulife from "../../img/SF/Manulife.png";
import VoxSmart from "../../img/SF/VoxSmart.png";
import Uber from "../../img/SF/Uber.png";
import chefs from "../../img/SF/chefs.png";
import REDspace from "../../img/SF/REDspace.png";
import Accenture from "../../img/SF/Accenture.png";
import RedHat from "../../img/SF/RedHat.png";
import Buffer from "../../img/SF/Buffer.png";
import Meta from "../../img/SF/Meta.png";

const SpeakersFrom = (props) => { 
    const state = {
        Speakers_item: [
            {
                img: Microsoft,
            },
            {
                img: Accenture,
            },
            {
                img: RedHat,
            },
            {
                img: FreeNow,
            },
            {
                img: Uber,
            },
            {
                img: Meta,
            },
            {
                img: TBC,
            },
            {
                img: PicsartArmenia,
            },
            {
                img: Buffer,
            },
            {
                img: Doist,
            },
            {
                img: Xamarin,
            },
            {
                img: HokenTech,
            },
            {
                img: Bangla,
            },
            {
                img: Konfio,
            },
            {
                img: Manulife,
            },
            {
                img: VoxSmart,
            },
            {
                img: chefs,
            },
            {
                img: SensibleMobile,
            },
            {
                img: REDspace,
            },
      ],
    };

    const renderSpeakers_item = (item, i) => {
        return (
            <div className="logo_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Speakers logo" />
            </div>
        );
    };

    return (
        <div className="speakers_from container">
            <h3>Speakers from</h3>
            <div className="sf">
                {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
            </div>
        </div>
    );
};

export default SpeakersFrom;